import { useEffect, useRef, useState } from "react";

import { calculateValueFromEvent } from "../Utils";
import ComboSelect from "../ComboSelect";
import PatternField from "../PatternField";
import { Box } from "@mui/material";
import { verificaTag } from "../TagFunctions";

const PREFIJOS = [
    { value: 'IMDM', text: 'IMDM' },
    { value: 'CPFI', text: 'CPFI' },

]

const defaultData = (value) => ({
    prefijo: value.prefijo || 'IMDM',
    numero: value.numero || '',
    div: value.div || '',
})

export const TagField = ({ onChange, disabled = false, clearable = false, value = {}, reset, div = false, readOnly = false, ...props }) => {

    const [readOnlyProps] = useState(readOnly ? { readOnly: true } : {});
    const [data, setData] = useState(defaultData(value));
    const [isValid, setIsValid] = useState(true);
    const [dirty, setDirty] = useState(false);

    const inputRefDiv = useRef(null);
    const inputRefNumero = useRef(null);

    useEffect(() => {
        //console.log('value', value);
        if (value && isTagValid(value.prefijo + value.numero)) {
            setData(defaultData(value));
        }
    }, [value]);

    useEffect(() => {
        //console.log('reset', reset);
        if (reset) {
            setData(defaultData({}));
            inputRefNumero.current.focus();
        }
    }, [reset]);

    useEffect(() => {
        var valid = false;
        if (numeroIsValid()) {
            if (div && data.div !== '' && data.div.toString().length === 1) {
                valid = verificaTag(data.prefijo, '' + data.numero + data.div);
                setIsValid(valid);
            } else {
                setIsValid(true);
                if (inputRefDiv.current) {
                    inputRefDiv.current.focus();
                }
            }
        } if (data.numero === '' && data.div === '') {
            setIsValid(true);
        }

        if (onChange && dirty) {
            setDirty(false);
            onChange(data, valid);
        }
    }, [data.prefijo, data.numero, data.div]);

    const handleChangeValue = name => event => {
        const value = calculateValueFromEvent(event);

        if (name === 'numero') {
            if (value.toString().length < 8 && data.div !== '') {
                setDirty(true);
                setData({
                    ...data,
                    div: '',
                    [name]: value
                });
                return;
            }
        }

        setData({
            ...data,
            [name]: value
        });
        setDirty(true);
    }

    function isTagValid(cadena) {
        const regex = /^(IMDM|CPFI)\d{8}$/;
        return regex.test(cadena);
    }


    const numeroIsValid = () => {
        return data.numero !== '' && data.numero.toString().length === 8;
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 1 }}>
            <ComboSelect
                disabled={disabled}
                clearable={clearable}
                sx={{ width: 110 }}
                label="Prefijo tag"
                field="prefijo"
                value={data.prefijo}
                InputProps={{ ...readOnlyProps }}
                onChange={handleChangeValue('prefijo')}
                options={PREFIJOS}
                error={!isValid}
                helperText={!isValid ? "Tag inválido" : ""}
            />
            <PatternField
                inputRef={inputRefNumero}
                disabled={disabled}
                clearable={clearable}
                sx={{ width: 110 }}
                label="Número tag"
                formatter={{
                    format: "########"
                }}
                field={'numero'}
                value={data.numero}
                InputProps={{ ...readOnlyProps }}
                onChange={handleChangeValue('numero')}
                //helperText="8 dígitos"
                error={!isValid}
            />
            {div &&
                <PatternField
                    inputRef={inputRefDiv}
                    disabled={disabled || !numeroIsValid()}
                    clearable={clearable}
                    sx={{ width: 55 }}
                    label="D.V."
                    formatter={{
                        format: "#"
                    }}
                    field={'div'}
                    value={data.div}
                    onChange={handleChangeValue('div')}
                    //helperText="1 dígito"
                    error={!isValid}
                />
            }
        </Box>

    );
}